<users [resourceType]="resourceType"></users>
